<template>
  <div>
    <div class="top">
      <my-search
        :order="2"
        timeScreen
        :selectArr="selectArr"
        :searchParams="searchParams"
        @searchEvent="searchEvent"
      />
      <el-button
        type="primary"
        icon="el-icon-plus"
        circle
        class="addBtn"
        @click="adDictionary"
      ></el-button>
    </div>

    <myTable
       ref="table"
      :loading="loading"
      :tableData="tableData"
      :tableHeader="tableHeader"
    />
    <!-- 分页组件 -->
    <my-pagination :childMsg="pageParams" @callFather="callFather" />

    <my-dialog
      :isDialogShow.sync="isDialogShow"
      :operTitle="operTitle"
      :operForm="operForm"
      :operFormArr="operFormArr"
      :selectArrAdd="selectArrAdd"
      :rules="rules"
      :loading="loading"
      @submitForm="submitForm"
      @getCurrent="getCurrent"
    />
    <!-- 详情组件 -->
    <my-dialog-detail
      :isDialogDetailShow.sync="isDialogDetailShow"
      :operForm="operForm"
      :operFormArr="detailArr"
      :closeDialog="closeDialog"
    />
  </div>
</template>

<script>
import {
  reqdictList,
  reqAdddict,
  reqDeletedict,
  reqUpdatedict,
  reqSelect,
  reqMax,
} from "@/network/other/dictionaryManage";
import mixins from "@/mixins/common";
import { canSearch } from "../../utils/utils";
export default {
  name: "dictionaryManage",
  mixins: [mixins],
  data() {
    return {
      // pageParams: {},
      tableHeader: Object.freeze([
        {
          name: "类型",
          prop: "property",
        },
        {
          name: "描述",
          prop: "name",
        },
        {
          name: "value",
          prop: "value",
        },
        {
          name: "创建时间",
          prop: "createTime",
        },
        {
          name: "操作",
          prop: "operation",
          width: "300",
          operation: [
            {
              name: "详情",
              clickFun: this.detail,
            },
            {
              name: "编辑",
              clickFun: this.edit,
            },
            {
              name: "删除",
              clickFun: this.delete,
            },
          ],
        },
      ]),
      searchParams: { timeOptions: [], parentid: "" },
      selectArr: [
        {
          name: "parentid",
          defaultText: "请选择类型",
          getData: "value",
          defaultOptions: [],
        },
      ],
      selectArrAdd: [
        {
          disabled: false,
          prop: "current",
          label: "类型",
          getData: "value",
          defaultOptions: [],
        },
      ],
      //添加、编辑时文本框所需参数
      operFormArr: [
        {
          disabled: true,
          name: "value",
          label: "value",
        },
        {
          name: "name",
          label: "描述",
          defaultText: "请输入描述",
        },
      ],
      detailArr: [
        {
          name: "property",
          label: "类型",
          defaultText: "请选择类型",
        },
        {
          disabled: true,
          name: "value",
          label: "value",
        },
        {
          name: "name",
          label: "描述",
          defaultText: "请输入描述",
        },
      ],
      // 弹出框的表单验证
      rules: {
        name: [
          {
            required: true,
            message: "请输入描述",
            trigger: "blur",
          },
        ],
        current: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change",
          },
        ],
      },
      //添加、编辑双向绑定值
      operForm: {
        name: "", //描述
        current: {}, //选中的下拉
        value: "", //根据接口获取到的
      },
    };
  },
  methods: {
    // 搜索数据
    async firstTypeList() {
      let { data } = await reqSelect();
      if (data.code == 200) {
        data.data.forEach((element) => {
          this.selectArr[0].defaultOptions.push({
            value: element.id,
            label: element.property,
          });
        });
        data.data.map((item) => {
          item.label = item.property;
          // value: `${element.id}-${element.type}-${element.property}`,
          item.value = item.id;
        });
        this.selectArrAdd[0].defaultOptions = data.data;
      }
    },
    // 默认展示
    async getInitData(isSearch) {
      // 清除高亮
      this.$refs.table.handleRowdbClick()
      
      let { timeOptions, parentid } = this.searchParams;
      let params = {
        data: { parentid },
        current: isSearch ? 1 : this.pageParams.currentPage,
        size: this.pageParams.pageSize,
        startTime: timeOptions ? timeOptions[0] : "",
        endTime: timeOptions ? timeOptions[1] : "",
      };
      let { data } = await reqdictList(params);
      if (data.code == 200) {
        this.loading = false;
        this.tableData = data.data.records;
        this.pageParams.total = data.data.total;
        if (isSearch) this.pageParams.currentPage = 1;
      }
    },
    //  搜索事件
    searchEvent() {
      // 只限制搜索参数
      // if (isUser && canSearch(this, this.searchParams)) return;
      // console.log("搜索了");
      this.getInitData(true);
    },
    //详情
    detail(row) {
      this.isDialogDetailShow = true;
      // 显示
      this.operForm = {
        ...row,
      };
    },
    // 编辑
    edit(row) {
      this.selectArrAdd[0].disabled = true;
      this.operFormArr[0].disabled = false;
      this.operTitle = false;
      this.isDialogShow = true;
      // 展示current字段为property属性值
      row.current = row.property;
      this.operForm = {
        ...row,
      };
    },
    // 删除
    delete(row) {
      this.$confirm("删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let { data } = await reqDeletedict(row.id);
          if (data.code == 200) {
            this.$message.success("删除成功");
            this.getInitData();
          }
        })
        .catch(() => {});
    },
    // 添加
    adDictionary() {
      this.selectArrAdd[0].disabled = false;
      this.operFormArr[0].disabled = true;
      // 清空
      this.operForm = {};
      this.operTitle = true;
      this.isDialogShow = true;
    },
    //
    async submitForm({ valid, operTitle }) {
      // operTitle ture添加  否则是编辑
      if (valid) {
        var api;
        var params;
        if (operTitle) {
          api = reqAdddict;
          let {
            current: { id: parentid, property, type: parentType },
            name,
            value,
          } = this.operForm;
          params = {
            name,
            parentid,
            property,
            parentType,
            value,
          };
        } else {
          api = reqUpdatedict;
          let { id, name, value } = this.operForm;
          params = {
            name,
            id,
            value,
          };
        }
        let { data } = await api(params);
        if (data.code == 200) {
          this.isDialogShow = false;
          this.$message.success("操作成功");
          this.getInitData();
        }
      }
    },
    //获取当前行
    async getCurrent(val) {
      if (!val) {
        this.operForm.value = "";
        return;
      }
      let { data } = await reqMax({ type: val.type });
      data.code == 200 && this.$set(this.operForm, "value", data.data);
    },
  },
  created() {
    this.firstTypeList();
  },
};
</script>

<style scoped>
.top {
  height: 100px;
  background-color: #f2f2f2;
  display: flex;
  align-items: center;
  padding: 0 30px;
}
.addBtn {
  margin: 0 0 10px 10px;
}
</style>